import * as firestoreService    from  '../../common/firestore.service';
import { firebaseApp } from '../../common/config.service';
import firebase               from    'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

import { User } from './user.model';

// export async function login(phone: string, pin: string): Promise<any> {
//     console.log(phone, pin)
//     return new Promise(async (resolve, reject) => {
        // const user: User = await firestoreService.fetchDocument('Users', phone, User);
//         console.log(user)
//         if(user.id !== "") {
//             if(user.pin === pin) {
//                 if(user.active) {
//                     resolve({login: true, user});
//                 }
//                 else {
//                     resolve({login: false, reason: 'NOT_ACTIVE'});
//                 }
//             } else {
//                 resolve({login: false, reason: 'PIN'});
//             }
//         } else {
//             resolve({login: false, reason: 'PHONE'});
//         }
//     });
// }
declare global {
    interface Window { confirmationResult:any }
}
export function login(phone: string) {
  
    return new Promise((resolve, reject) => {
        firebaseApp.auth().languageCode = 'en';
        const phoneNumber = '+91'+    phone;
        console.log(phoneNumber)
        const appVerifier = window.recaptchaVerifier;
        firebaseApp.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
            .then((confirmationResult) => {
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            resolve({otpSend:true})
            window.confirmationResult = confirmationResult;
            // ...
            }).catch((err) => {
            // Error; SMS not sent
            // ...
            if(err.code === 'auth/user-not-found') resolve({otpSend: false, reason: 'EMAIL'})
            else if(err.code === 'auth/wrong-password') resolve({otpSend: false, reason: 'PIN'})
            else resolve({otpSend: false })
            });
    /*    firebaseApp.auth()
        .signInWithEmailAndPassword(email, pin)
        .then(async (res: any) => {
            const user: User = await firestoreService.fetchDocument('Users', email, User);
            resolve({login: true, user})
        })
        .catch((err:any) => {
            if(err.code === 'auth/user-not-found') resolve({login: false, reason: 'EMAIL'})
            else if(err.code === 'auth/wrong-password') resolve({login: false, reason: 'PIN'})
            else resolve({login: false })
        });*/
    });
}
export  function  submitOtp(otp: string,phone: string) {
  
    return new Promise((resolve, reject) => {
        
        const confirmationResult = window.confirmationResult ;
        const code = otp;
        confirmationResult.confirm(code).then(async(result:any) => {
        // User signed in successfully.
        //const user = result.user;
        var credential = firebase.auth.PhoneAuthProvider.credential(confirmationResult.verificationId, code);
        firebase.auth().signInWithCredential(credential);
        const user = await firestoreService.query1Collection('Users',"mobile", phone, User);
        if(user.length===0){
            resolve({login:false,reason:"NOT_REG"})

        }
        else{
             resolve({login:true,user})
        }
        // ...
        }).catch((error:any) => {
        // User couldn't sign in (bad verification code?)
        // ...
        });
    });
}

export async function updateUser(user: User) {
    await firestoreService.updateDocument('Users', user.email, user.toJson())
    sessionStorage.setItem('me', JSON.stringify(user.toJson()));
}

export const isLoggedIn = () => {
    const me = sessionStorage.getItem('me');
    return me !== null;
}

export const getUser = () => {
    if(isLoggedIn()) {
        return JSON.parse(sessionStorage.getItem('me') + '');
    }
}

export function logout() {
    firebaseApp.auth().signOut();
}